"use client";

import { useSyncExternalStore } from "react";

const createDebounce = (fn: () => void, delay: number) => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    const debounced = () => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(fn, delay);
    };
    debounced.cancel = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    return debounced;
};

let currentWidth = typeof window !== "undefined" ? window.innerWidth : 0;
const subscribers = new Set<() => void>();

const notify = createDebounce(() => {
    currentWidth = window.innerWidth;
    subscribers.forEach((cb) => cb());
}, 200);

const subscribe = (callback: () => void) => {
    if (subscribers.size === 0) {
        window.addEventListener("resize", notify);
    }
    subscribers.add(callback);

    return () => {
        subscribers.delete(callback);
        if (subscribers.size === 0) {
            window.removeEventListener("resize", notify);
            notify.cancel();
        }
    };
};

const getSnapshot = () => currentWidth;
const getServerSnapshot = () => 0;

export const useScreenWidth = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
